import { ReactNode, useRef } from "react";

import { EnvironmentVariable } from "components/Environment/types";
import Table from "ds/components/Table";
import TableBody from "ds/components/Table/Body";
import TableWrapper from "ds/components/Table/Wrapper";
import TableSimpleHead from "ds/components/TableSimple/Head";
import { TableSimpleStore } from "ds/components/TableSimple/types";

import tableStyles from "../styles.module.css";
import EnvironmentMountedFilesTableRows from "./Rows";

type EnvironmentMountedFilesTableProps = {
  data: EnvironmentVariable[];
  store: TableSimpleStore;
  ariaLabel: string;
  activeRowId?: string;
  emptyState?: ReactNode;
};

const EnvironmentMountedFilesTable = ({
  data,
  store,
  ariaLabel,
  activeRowId,
  emptyState,
}: EnvironmentMountedFilesTableProps) => {
  const tableRef = useRef<HTMLDivElement>(null);

  return (
    <TableWrapper ref={tableRef} hasPagination={false} className={tableStyles.contentHeight}>
      <Table ariaLabel={ariaLabel}>
        <TableSimpleHead store={store} ariaLabel={ariaLabel} tableRef={tableRef} />
        <TableBody>
          <EnvironmentMountedFilesTableRows data={data} store={store} activeRowId={activeRowId} />
        </TableBody>
      </Table>
      {data.length === 0 && emptyState}
    </TableWrapper>
  );
};

export default EnvironmentMountedFilesTable;
